var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{style:(_vm.headerBackgroundColor)},[(_vm.logo)?_c('img',{staticClass:"logo d-none d-md-block",attrs:{"src":_vm.logo,"alt":_vm.logoTitle}}):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"title",style:(_vm.headerTitleColor)},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }